import styled from "styled-components";

export const DialogWrapper = styled.div<{ isCancel: boolean; isWide: boolean }>`
  position: fixed;
  width: ${({ isWide }) => (isWide ? "484px" : "calc(100% - 32px)")};
  box-sizing: border-box;
  top: 50%;
  left: 50%;
  padding: 53px 15px 24px 15px;
  transform: translate(-50%, -50%);
  z-index: 1111;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 63px;

  > .title {
    text-align: center;
    word-break: break-word;
    white-space: pre-line;
    color: var(--Black-500, #202020);
    text-align: center;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 35px */
  }

  > .button-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 8px;

    > .cancel-button {
      padding: 15px 0;
      display: flex;
      width: 135px;
      justify-content: center;
      align-items: center;
      color: var(--Purple-300, #6436e7);
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
      cursor: pointer;
    }

    > .create-button {
      cursor: pointer;
      display: flex;
      width: ${(p) => (p.isCancel ? "341px" : "100%")};
      padding: 15px 0;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 8px;
      background: #d91818;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
    }

    > .white-button {
      padding: 15px 0;
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      color: var(--Purple-300, #6436e7);
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
      cursor: pointer;
    }

    > .purple-button {
      padding: 15px 0;
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      background: var(--Purple-300, #6436e7);
      border-radius: 8px;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
      cursor: pointer;
    }

    > .red-button {
      padding: 15px 0;
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      background: #ff0000;
      border-radius: 8px;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.165px;
      cursor: pointer;
    }
  }
`;
